(() => {
  'use strict';
  const dialog = document.querySelector('[data-welcome-offer]');
  if (!dialog?.showModal || window.Shopify?.designMode) return;
  const key = 'dresscode-welcome-offer-until';
  const pendingKey = 'dresscode-welcome-offer-pending';
  const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
  const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch { /* Signup works without storage. */ } };
  const suppress = days => write('localStorage', key, String(Date.now() + days * 86400000));
  const show = () => {
    if (document.hidden || document.querySelector('dialog[open]') || document.body.classList.contains('menu-open')) return false;
    if (document.activeElement?.matches('input,textarea,select')) return false;
    dialog.showModal();
    document.body.classList.add('dialog-open');
    dialog.querySelector('.welcome-offer-close').focus();
    return true;
  };
  dialog.addEventListener('close', () => {
    suppress(dialog.querySelector('[data-welcome-success]') ? 365 : 30);
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
  });
  dialog.querySelector('form').addEventListener('submit', () => {
    write('sessionStorage', pendingKey, '1');
    // Shopify may pause submission for its spam challenge. Keep retry available.
  });
  const pending = read('sessionStorage', pendingKey) === '1';
  const success = dialog.querySelector('[data-welcome-success]');
  const errors = dialog.querySelector('[data-welcome-errors]');
  if (pending && (success || errors)) {
    write('sessionStorage', pendingKey, '0');
    if (success) suppress(365);
    show();
    return;
  }
  if (Number(read('localStorage', key)) > Date.now() || success) return;
  // Give visitors time to browse before showing the offer; defer while they are engaged.
  window.setTimeout(() => {
    const tryShow = () => {
      if (show()) { suppress(30); return; }
      window.setTimeout(tryShow, 5000);
    };
    tryShow();
  }, 20000);
})();
